import { FunnelSimple } from "@phosphor-icons/react";
import { useState } from "react";

import { Button } from "common/components/ui/Button";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerTitle,
  DrawerTrigger,
} from "common/components/ui/Drawer";
import FormField from "common/components/ui/FormField";
import WorkspaceAccountSelector from "common/components/WorkspaceAccountSelector";
import type { Campaign, CampaignState } from "common/types";

import StateFilter from "../StateFilter";

import type { CampaignsSearchParams } from "../../../types";

interface MobileFiltersProps {
  campaigns: Campaign[];
  currentFilters: CampaignsSearchParams;
  clearFilters: () => void;
  applyFilters: (newFilters: CampaignsSearchParams) => void;
}

export default function MobileFilters({
  campaigns,
  currentFilters,
  clearFilters,
  applyFilters,
}: MobileFiltersProps) {
  const [selectedAccountIds, setSelectedAccountIds] = useState<string[]>(
    currentFilters.owners,
  );
  const [campaignStates, setCampaignStates] = useState<CampaignState[]>(
    currentFilters.status,
  );

  function onApply() {
    applyFilters({
      owners: selectedAccountIds,
      status: campaignStates,
    });
  }

  return (
    <Drawer
      onOpenChange={() => {
        // Reset Filters
        setSelectedAccountIds(currentFilters.owners);
        setCampaignStates(currentFilters.status);
      }}
    >
      <DrawerTrigger asChild>
        <Button variant="outline-black" intent="iconOnly" size="lg">
          <FunnelSimple />
        </Button>
      </DrawerTrigger>
      <DrawerContent>
        <DrawerTitle className="mb-4">Campaign filters</DrawerTitle>
        <FormField label="Filter by account" htmlFor="" className="mb-4">
          <WorkspaceAccountSelector
            selection={selectedAccountIds}
            setSelection={setSelectedAccountIds}
          />
        </FormField>
        <FormField label="Filter by status" htmlFor="">
          <StateFilter
            selectedFilters={campaignStates}
            setFilters={setCampaignStates}
            campaigns={campaigns}
          />
        </FormField>
        <DrawerClose asChild>
          <Button size="lg" className="mb-2 mt-8" onClick={onApply}>
            Apply filters
          </Button>
        </DrawerClose>
        <DrawerClose asChild>
          <Button
            size="lg"
            variant="outline-black"
            onClick={() => clearFilters()}
          >
            Clear all filters
          </Button>
        </DrawerClose>
      </DrawerContent>
    </Drawer>
  );
}
